<template>
    <div>
        <page-title heading="Subskripsi" :breadcrumb="[
        {
          label: 'Subskripsi',
          link: '/subskripsi',
        },
          {
          label: 'List Subskripsi',
          active: true
        }
      ]" />
        <template v-if="this.adaTagihan === true">
            <div>
                <div class="container-fluid">
                    <div class="row justify-content-center">
                        <div class="col-md-12  text-center" style="font-size:16px;">
                            <div class="card-body bg-sunny-morning">
                                <strong style="color:black;">Anda masih memiliki tagihan yang belum terbayar. Klik <button @click="goto('ScrollActivate')" style="color: #3b86ff; border: 0px; background: transparent"><strong>DISINI</strong></button> untuk melihat lebih lanjut</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="
            isNewPackage 
            && currentActivePackage.sisa_hari <= 30 
            && currentActivePackage.sisa_kouta >= 10"
            >
            <div>
                <div class="container-fluid">
                    <div class="row justify-content-center">
                        <div class="col-md-12  text-center">
                            <div class="alert alert-perpanjang mt-2">
                                    Saat ini masa berlaku paket anda akan berakhir, segera perpanjang masa berlaku atau beli paket berlangganan untuk menikmati fitur di izidok
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="Object.keys(dataPackage).length == 0 && lastActivePackage"
            >
            <div>
                <div class="container-fluid">
                    <div class="row justify-content-center">
                        <div class="col-md-12  text-center">
                            <div class="alert alert-perpanjang mt-2">
                                    Saat ini paket anda telah berakhir, segera beli paket berlangganan untuk menikmati fitur di izidok.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div class="app-content--inner p-0 d-flex flex-column">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col-md-12 text-uppercase" style="font-size:13px;">
                        <div class="card card-box mb-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12 text-center">
                                        <h3>PAKET ANDA SAAT INI</h3>
                                    </div>
                                    <div class="col-md-12">
                                        <div
                                            v-if="Object.keys(dataPackage).length > 0"
                                            class="card card-box borders-0 mt-2 font_paket"
                                            style="background-color:#f2f2f2;border-radius:10px;"
                                        >
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 pr-0"><label>Paket</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                <template v-if="dataActive.message === 'package not found'">
                                                                    <label>- </label>
                                                                </template>
                                                                <template v-if="dataActive.message !== 'package not found'">
                                                                    <label>{{dataPackage.paket}}</label>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 p-0"><label>Status</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                <template v-if="dataActive.message === 'package not found'">
                                                                    <label>-</label>
                                                                </template>
                                                                <template v-if="dataActive.message !== 'package not found'">
                                                                    <label><label class="btn-primary" style="padding-left: 5px; padding-right: 5px; border-radius: 4px;">Aktif</label></label>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 p-0"><label>Sisa Kuota</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                <template v-if="dataActive.message === 'package not found'">
                                                                    <label>-</label>
                                                                </template>
                                                                <template v-if="dataActive.message !== 'package not found'">
                                                                    <template v-if="dataPackage.sisa_kouta == 'Unlimited'">
                                                                        Unlimited
                                                                    </template>
                                                                    <template v-else>
                                                                        <label><label :class="dataPackage.sisa_kouta == 0 ? 'btn-danger' : 'btn-primary'" style="padding-left: 6px; padding-right: 5px;  border-radius: 4px;">{{dataPackage.sisa_kouta}}</label> dari {{dataPackage.jumlah_kouta}}</label>
                                                                    </template>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 pr-0"><label>Pembelian</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                <template v-if="dataActive.message === 'package not found'">
                                                                    <label>-</label>
                                                                </template>
                                                                <template v-if="dataActive.message !== 'package not found'">
                                                                    <template v-if="dataPackage.pembelian === null">-</template>
                                                                    <template v-else><label>{{ dataPackage.pembelian }}</label></template>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 p-0"><label>Masa Berlaku</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                <template v-if="dataActive.message === 'package not found'">
                                                                    <label>-</label>
                                                                </template>
                                                                <template v-if="dataActive.message !== 'package not found'">
                                                                    <label>{{ dataPackage.mulai_berlaku }}</label>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 p-0"><label>Habis Berlaku</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                <template v-if="dataActive.message === 'package not found'">
                                                                    <label>-</label>
                                                                </template>
                                                                <template v-if="dataActive.message !== 'package not found'">
                                                                    <label>{{ dataPackage.habis_berlaku }}</label>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            v-if="Object.keys(dataPackage).length == 0 && lastActivePackage"
                                            class="card card-box borders-0 mt-2 font_paket"
                                            style="background-color:#f2f2f2;border-radius:10px;"
                                        >
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 pr-0"><label>Paket</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                    <label>{{lastActivePackage.paket.nama}}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 p-0"><label>Status</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                <label><label class="btn-danger" style="padding-left: 5px; padding-right: 5px; border-radius: 4px;">Tidak Aktif</label></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 p-0"><label>Sisa Kuota</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                <label><label :class="dataPackage.sisa_kouta == 0 ? 'btn-danger' : 'btn-primary'" style="padding-left: 6px; padding-right: 5px;  border-radius: 4px;">{{lastActivePackage.limit}}</label> dari {{lastActivePackage.quota}}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 pr-0"><label>Pembelian</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                {{ lastActivePackage.billing.pay_date }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 p-0"><label>Masa Berlaku</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                <label>{{ lastActivePackage.mulai_berlaku }}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 p-0"><label>Habis Berlaku</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                <label>{{ lastActivePackage.habis_berlaku }}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            v-if="Object.keys(dataAddOn).length > 0"
                                            class="card card-box borders-0 mt-2 card_add_on font_paket"
                                            style="background-color:#f2f2f2;border-radius:10px;"
                                        >
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <label>Add-On</label>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 pr-0"><label>Jenis Add-On</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 pl-0 text-right">
                                                                <template v-if="dataActive.message === 'package not found'">
                                                                    <label>-</label>
                                                                </template>
                                                                <template v-if="dataActive.message !== 'package not found'">
                                                                    <label>Patient Engagement whatsapp/sms</label>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 p-0"><label>Pembelian</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                <template v-if="dataActive.message === 'package not found'">
                                                                    <label>-</label>
                                                                </template>
                                                                <template v-if="dataActive.message !== 'package not found'">
                                                                    <template v-if="dataAddOn.pembelian === null">-</template>
                                                                    <template v-else><label>{{dataAddOn.tanggal_pembelian}}</label></template>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="row">
                                                            <div class="col-sm-5 p-0"><label>Sisa Kuota WA</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                <template v-if="dataAddOn.sisa_kuota_wa === null">
                                                                    <label>-</label>
                                                                </template>
                                                                <template v-else>
                                                                    <template v-if="dataActive.message !== 'package not found'">
                                                                        <label>
                                                                            <label :class="dataAddOn.sisa_kuota_wa != 0 ? 'btn-primary' : 'btn-danger'" style="padding-left: 6px; padding-right: 5px;  border-radius: 4px;">{{dataAddOn.sisa_kuota_wa}}</label> dari {{dataAddOn.kuota_wa}}
                                                                        </label>
                                                                    </template>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4 offset-8">
                                                        <div class="row">
                                                            <div class="col-sm-5 p-0"><label>Sisa Kuota SMS</label></div>
                                                            <div class="col-sm-1 p-0">:</div>
                                                            <div class="col-sm-6 p-0">
                                                                <template v-if="dataAddOn.sisa_kuota_sms == null">
                                                                    <label>-</label>
                                                                </template>
                                                                <template v-else>
                                                                    <template v-if="dataActive.message !== 'package not found'">
                                                                        <label>
                                                                            <label :class="dataAddOn.sisa_kuota_sms != 0 ? 'btn-primary' : 'btn-danger'" style="padding-left: 6px; padding-right: 5px;  border-radius: 4px;">{{dataAddOn.sisa_kuota_sms}}</label> dari {{dataAddOn.kuota_sms}}
                                                                        </label>
                                                                    </template>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <b-row class="mt-4">
                                            <b-col class="text-center">
                                                <router-link :to="{name: 'klinik-subskripsi-paket', params: { type: 'berlangganan' }}" class="btn btn-primary text-uppercase btn-radius">
                                                    Beli Paket Berlangganan
                                                </router-link>
                                            </b-col>
                                            <b-col class="text-center">
                                                <router-link :to="{name: 'klinik-subskripsi-paket', params: { type: 'add-on' }}" class="btn btn-paket text-uppercase btn-radius">
                                                    Beli Kuota Add-On
                                                </router-link>
                                            </b-col>
                                            <b-col v-if="isNewPackage" class="text-center">
                                                <a target="_blank" href="https://api.whatsapp.com/send/?phone=628111137982&text=Hai Izidok, saya ingin menambah masa berlaku. Mohon info terkait harga paket perpanjangan masa berlaku." class="btn btn-paket btn-radius btn-masa-berlaku">Beli Masa Berlaku</a>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="card card-box mb-2 mt-3" style="border-radius:15px;">
                            <div class="card-body">
                                <div class="col-md-12 text-center">
                                    <strong class="__text-blue" style="font-size:18px">DETAIL PAKET IZIDOK</strong>
                                </div>
                                <div class="col-md-12">
                                    <b-tabs card class="__custom-tab">
                                        <b-tab title="BELUM AKTIF" active>
                                            <table class="table table-striped table-hover mb-0">
                                                <thead class="thead-light ">
                                                    <tr class="text-capitalize" style="backgroud-color:#f5f5f5">
                                                        <th scope="col" class=" __text-blue p-3" style="border-top:none;border-bottom:none">Waktu Pembelian</th>
                                                        <th scope="col" class=" __text-blue p-3" style="border-top:none;border-bottom:none">
                                                            Paket
                                                        </th>
                                                        <th scope="col" class=" __text-blue p-3" style="border-top:none;border-bottom:none">
                                                            jumlah Kuota
                                                        </th>
                                                        <th scope="col" class=" __text-blue p-3" style="border-top:none;border-bottom:none;border-radius: 15px;">
                                                            Action
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody class="list">
                                                    <tr v-for="(data) in dataNotActive" :key="data.id">
                                                        <td class="text-wrap" style="border-top:none;border-bottom:none">
                                                            <div class="align-box-row">
                                                                <div class="d-flex align-items-center">
                                                                    <span> {{ data.waktu_pembelian == null ? "-" : convertDate(data.waktu_pembelian) }}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td class="text-wrap" style="border-top:none;border-bottom:none">
                                                            <div class="align-box-row">
                                                                <span class="d-block">
                                                                    {{ data.nama }}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td class="text-wrap" style="border-top:none;border-bottom:none">
                                                            <div class="align-box-row">
                                                                <span class="d-block">
                                                                    {{ data.jumlah_kouta }} visit
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td class="text-wrap" style="border-top:none;border-bottom:none">
                                                            <div class="align-box-row">
                                                                <span class="d-block">
                                                                    <b-button @click="detailNotActive(data.id, 'belum aktif')" class="__icon_search" size="sm" v-tooltip="'Detail Paket'">
                                                                        <font-awesome-icon icon="search" />
                                                                    </b-button>
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <b-pagination class="__custom-pagination d-flex justify-content-center mt-4" v-model="currentPageNotActive" :total-rows="rowsBelumAktif" :per-page="perPageBelumAktif"></b-pagination>
                                        </b-tab>
                                        <b-tab title="BERAKHIR">
                                            <table class="table table-striped table-hover mb-0">
                                                <thead class="thead-light">
                                                    <tr class="text-capitalize" style="backgroud-color:#f5f5f5">
                                                        <th scope="col" class=" __text-blue p-3" style="border-top:none;border-bottom:none">Waktu Pembelian</th>
                                                        <th scope="col" class=" __text-blue p-3" style="border-top:none;border-bottom:none">
                                                            Paket
                                                        </th>
                                                        <!-- <th scope="col" class=" __text-blue p-3" style="border-top:none;border-bottom:none">
                                                            Mulai Berlaku
                                                        </th>
                                                        <th scope="col" class=" __text-blue p-3" style="border-top:none;border-bottom:none">
                                                            Habis Berlaku
                                                        </th> -->
                                                        <th scope="col" class=" __text-blue p-3" style="border-top:none;border-bottom:none;border-radius: 15px;">
                                                            Action
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody class="list">
                                                    <tr v-for="(data) in dataPaketExpired" :key="data.id">
                                                        <td class="text-wrap" style="border-top:none;border-bottom:none">
                                                            <div class="align-box-row">
                                                                <div class="d-flex align-items-center">
                                                                    <span>{{ convertDate(data.waktu_pembelian)}} </span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td class="text-wrap" style="border-top:none;border-bottom:none">
                                                            <div class="align-box-row">
                                                                <span class="d-block">
                                                                    {{ data.nama }}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <!-- <td class="text-wrap" style="border-top:none;border-bottom:none">
                                                            <div class="align-box-row">
                                                                <span class="d-block">
                                                                    {{ convertDateWithoutTime(data.mulai_berlaku) }}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td class="text-wrap" style="border-top:none;border-bottom:none">
                                                            <div class="align-box-row">
                                                                <span class="d-block">
                                                                    {{ convertDateWithoutTime(data.habis_berlaku) }}
                                                                </span>
                                                            </div>
                                                        </td> -->
                                                        <td class="text-wrap" style="border-top:none;border-bottom:none">
                                                            <div class="align-box-row">
                                                                <span class="d-block">
                                                                    <b-button @click="detailNotActive(data.id, 'berakhir')" class="__icon_search"   size="sm" v-tooltip="'Detail Paket'">
                                                                        <font-awesome-icon icon="search" />
                                                                    </b-button>
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <b-pagination class="__custom-pagination d-flex justify-content-center mt-4" v-model="currentPageExpired" :total-rows="rowsExpired" :per-page="perPageExpired"></b-pagination>
                                        </b-tab>
                                    </b-tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div ref="ScrollActivate" class="col-md-12">
                        <div class="card card-box mb-2 mt-3" style="border-radius:15px;background-color:#fcfcfc">
                            <div class="card-body">
                                <div class="col-md-12 text-center">
                                    <strong  class="__text-blue" style="font-size:18px">RIWAYAT PEMBELIAN</strong>
                                </div>
                                <DataTableWrapper :perPage="perPage" :currentPage="currentPage" :callbackFunc="fetchRiwayatPembelian" @valueChanged="handleValueChanged">
                                    <b-table striped hover :items="dataRiwayatPembelian" :fields="fieldList" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" thead-tr-class="izd-datatable-custom" :no-local-sorting="true">
                                        <template v-slot:head()="data" >
                                           <strong  class="__text-blue"> {{ data.label }}</strong> 
                                            <b-input size="sm" class="mt-2 w-70" v-if="data.field.searchable" @input="searchValueChanged($event, data.field.key)" />
                                        </template>
                                        <template v-slot:cell(produk)="data">
                                            <span>{{data.item.produk}} <small class="__text-blue" v-if="data.item.promo != null">[{{data.item.promo}}]</small></span>
                                        </template>
                                        <template v-slot:cell(status_text)="data">
                                            <template v-if="data.item.status_text == 'Menunggu Pembayaran'">
                                               <div class="__card-coklat"><center><strong class="text-uppercase " style="color:white;font-size:12px">{{data.value}}</strong></center> </div> 
                                            </template>
                                            <template v-else-if="data.item.status_text == 'Lunas'">
                                                <div class="__card-blue"><center><strong class="text-uppercase " style="color:white;font-size:12px">{{data.value}}</strong></center></div>
                                            </template>
                                            <template v-else-if="data.item.status_text == 'Gagal'">
                                                <div class="__card-red"><center><strong class="text-uppercase " style="color:white;font-size:12px">{{data.value}}</strong></center></div>
                                            </template>
                                            <template v-else-if="data.item.status_text == 'Batal'">
                                                <div class="__card-red"><center><strong class="text-uppercase " style="color:white;font-size:12px">{{data.value}}</strong></center></div>
                                            </template>
                                        </template>
                                        <template v-slot:cell(actions)="data">
                                            <template v-if=" data.item.status_text == 'Batal' || data.item.status_text == 'Gagal'  ">
                                                <span>
                                                    <b-link class=" btn text-light font-size-md pl-2 pr-2 btn-sm " v-tooltip="'Lihat Struk'" disabled @click="detailBayar(data.item)" style="background-color:#bfbfbf;">
                                                        <font-awesome-icon icon="search" style="color:white;" />
                                                    </b-link>
                                                </span>
                                            </template>
                                            <template v-else>
                                                <span>
                                                    <b-link class="btn text-light font-size-md pl-2 pr-2 btn-sm __icon_search " v-tooltip="'Lihat Struk'" @click="detailBayar(data.item)">
                                                        <font-awesome-icon icon="search"  style="color:white;" />
                                                    </b-link>
                                                </span>
                                            </template>
                                            <template v-if=" data.item.status_text ==='Menunggu Pembayaran' && data.item.url_redirect == NULL ">
                                                <span>
                                                    <b-button size="sm" v-tooltip="'Detail Pembayaran'" style="background-color:blue;border-color:transparent;" @click="detailTagihan(data.item)" class="btn text-light font-size-md ml-1 pl-2 pr-2 btn-sm">
                                                        <font-awesome-icon icon="file" style="color:white;" />
                                                    </b-button>
                                                </span>
                                            </template>
                                            <template v-else-if=" data.item.status_text ==='Menunggu Pembayaran' && data.item.url_redirect !== ''  ">
                                                <span>
                                                    <b-button size="sm" v-tooltip="'Detail Pembayaran'" style="background-color:blue;border-color:transparent;" @click="goToBayarind(data.item.url_redirect)" class="btn text-light font-size-md ml-1 pl-2 pr-2 btn-sm">
                                                        <font-awesome-icon icon="file" style="color:white;"  />
                                                    </b-button>
                                                </span>
                                            </template>
                                        </template>
                                    </b-table>
                                </DataTableWrapper>
                            </div>
                        </div>
                    </div>
                    <b-modal ref="modalNotActive" size="lg" title="Detail Paket">
                        <div class="row">
                            <div class="col-md-4">
                                <strong>Nama Paket</strong>
                            </div>
                            <div class="col-md-8">
                                : <label class=" ml-3">{{belumAktif.nama}}</label>
                            </div>
                            <template v-if="currentTab == 'belum aktif'">
                            <div class="col-md-4">
                                <strong>Masa Berlaku</strong>
                            </div>
                            <div class="col-md-8">
                                : <label class=" ml-3">{{belumAktif.masa_berlaku}}</label>
                            </div>
                            </template>
                            <div class="col-md-4">
                                <strong>Fitur</strong>
                            </div>
                            <div class="col-md-8">
                                : <div class=" ml-4" style="margin-top: -22px">
                                    Dashboard Monitoring
                                    <br>
                                    e-Rekam Medis 
                                    <template v-if="belumAktif.nama == 'Essential-1' || belumAktif.nama == 'Essential-12'">
                                        ({{250 * belumAktif.paket_bln}} visit pasien)
                                    </template>
                                    <template v-else-if="belumAktif.nama == 'Premium-1' || belumAktif.nama == 'Premium-12'">
                                        Unlimited
                                    </template>
                                    <template v-else-if="belumAktif.jml_visit">
                                        {{ belumAktif.jml_visit }} visit pasien
                                    </template>
                                    <br>
                                    Daftar Pasien
                                    <br>
                                    Registrasi Pasien
                                    <br>
                                    Manajemen Antrian
                                    <br>
                                    Manajemen Tarif
                                    <br>
                                    Manajemen Asisten Dokter
                                    <br>
                                    Pembayaran
                                    <br>
                                    Engagement Pasien Via Email
                                </div>
                            </div>
                        </div>
                        <template v-slot:modal-footer>
                            <div class="w-100">
                                <b-button variant="primary" class="float-right" @click="hideModalNotActive">
                                    Tutup
                                </b-button>
                            </div>
                        </template>
                    </b-modal>
                    <b-modal ref="modal-bataltransaksi">
                        <div class="row" v-if="this.detailStruk !== null " style="font-size:14px;">
                            <div class="col-md-7">
                                <label class="float-left"><strong>Total Pembelian :</strong> Rp {{parseInt(dataDetailRiwayatPembelian.detail.amount_pay).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}}</label>
                            </div>
                            <div class="col-md-5">
                                <b-button variant="success" size="sm" class="float-right text-uppercase" @click="ToInvoice(dataDetailRiwayatPembelian.detail.billing_id)">
                                    Lihat Invoice
                                </b-button>
                            </div>
                            <div class="col-md-12">
                                <label class="float-left"><strong>Tanggal Pembelian :</strong> {{
                                    convertDateWithoutTime(dataDetailRiwayatPembelian.detail.transactionDate)
                                    }}</label>
                            </div>
                            <div class="col-md-12">
                                <div class="col-sm- text-center">
                                    <label style="background-color:#ded5d5;padding-left:50px; padding-right:50px; " class="text-danger mt-3 mb-3">Bayar Sebelum {{
                                        convertDate(dataDetailRiwayatPembelian.detail.transactionExpire)
                                        }}</label>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <label class="float-left"><strong>Metode Pembayaran</strong></label>
                            </div>
                            <div class="col-md-6">
                                <label class="float-left"><strong>:</strong> {{dataDetailRiwayatPembelian.paygate.nama}}</label>
                            </div>
                            <div class="col-md-5">
                                <label class="float-left"><strong>No. Virtual Account</strong></label>
                            </div>
                            <div class="col-md-6">
                                <label class="float-left"><strong>:</strong> {{dataDetailRiwayatPembelian.detail.customerAccount}}</label>
                            </div>
                        </div>
                        <div slot="modal-footer">
                            <div class="align-content-center">
                                <b-button variant="primary mr-2" @click="caraBayar(dataDetailRiwayatPembelian.detail.billing_id)">Lihat Cara Pembayaran</b-button>
                                <b-button variant="danger" rclass="btn-link-dark mr-4" @click='closeModalBatalTransaksi(dataDetailRiwayatPembelian.detail.id)'>Batalkan Transaksi</b-button>
                            </div>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import debounce from "lodash/debounce";
import moment from "moment";
moment.locale('id');
import {
    library
} from "@fortawesome/fontawesome-svg-core";
import {
    faArrowRight,
    faArrowUp,
    faTrashAlt,
    faEye,
    faFile,
    faEyeSlash,
    faSearch,
    faPencilAlt,
    faMoneyBillWave
} from "@fortawesome/free-solid-svg-icons";
import startCase from "lodash/startCase";
library.add(faArrowRight, faEye, faFile, faMoneyBillWave,
    faEyeSlash, faArrowUp, faTrashAlt, faSearch, faPencilAlt);
import {mapGetters} from "vuex";
export default {
    components: {
        DataTableWrapper: () => import("../../components/DataTableWrapperSubkripsi")
    },
    data() {
        return {
            fields: [{
                    label: 'WAKTU PEMBELIAN',
                    key: "waktu_pembelian",
                    thStyle: "width: 25%"
                },
                {
                    label: 'PAKET',
                    key: 'PAKET',
                    thStyle: "width: 25%"
                },
                {
                    label: 'JUMLAH KUOTA',
                    key: 'jumlah_kouta',
                    thStyle: "width: 25%"
                },
                {
                    label: 'ACTION',
                    key: 'action',
                    thStyle: "width: 25%"
                },
            ],
            dataTagihan: [],
            dataDetailRiwayatPembelian: [],
            dataRiwayatPembelian: [],
            dataNotActive: [],
            dataActive: [],
            dataExpired: [{
                nama: null,
            }],
            detailStruk: null,
            checkDataInvoice: [],
            belumAktif: [],
            searchValue: [],
            adaTagihan: false,
            detail: null,
            totalEntries: 0,
            sortBy: "",
            sortDesc: false,
            currentPage: 1,
            rows: 0,
            fromPage: 0,
            toPage: 0,
            perPage: 10,
            dataPaketExpired: [],
            currentPageExpired: 1,
            perPageExpired: 5,
            rowsExpired: 0,
            currentPageNotActive: 1,
            perPageBelumAktif: 5,
            rowsBelumAktif: 0,
            fromPageBelumAktif: 0,
            toPageBelumAktif: 0,
            dataPackage: {},
            dataAddOn: {},
            currentTab: 'belum aktif',
            isNewPackage: false,
            lastActivePackage: null,
            currentActivePackage: null,
        }
    },
    async mounted() {
        this.cekPaketNolock();
        this.fetchListNotActive();
        this.fetchListExpired();
        this.fetchActive();
        this.fetchUser();
        await this.checkBilling();
    },
    watch: {
        currentPageNotActive() {
            this.fetchListNotActive()
        },
        currentPageExpired() {
            this.fetchListExpired();
        },
        currentPage() {
            this.fetchRiwayatPembelian();
        },
        perPage() {
            this.fetchRiwayatPembelian();
        },
        sortBy() {
            this.fetchRiwayatPembelian();
        },
        sortDesc() {
            this.fetchRiwayatPembelian();
        },
        searchValue: {
            handler: "fetchRiwayatPembelian",
            deep: true
        }
    },
    computed: {
        ...mapGetters(["getKlinikId"]),
        fieldList() {
            const {
                generateFieldList: g,
                setSearchableAndSortableFieldList: s
            } = this;
            const r = val => Boolean(/(actions)\b/gi.test(val) ? !1 : 1);
            return (
                [{
                        key: "nomor_tagihan",
                        label: "No. Tagihan",
                        thStyle: "width: 17%"
                    },
                    {
                        key: "produk",
                        label: "Paket",
                        thStyle: "width: 15%"
                    },
                    // {
                    //     key: "periode_berlaku",
                    //     label: "Periode Berlaku",
                    //     thStyle: "width: 16%"
                    // },
                    {
                        key: "total_pembayaran",
                        label: "Total Bayar",
                        thStyle: "width: 13%"
                    },
                    {
                        key: "tanggal_bayar",
                        label: "Tanggal Bayar",
                        thStyle: "width: 15%",
                        class: ""
                    },
                    {
                        key: "status_text",
                        label: "status",
                        thStyle: "width: 12%",
                    },
                    {
                        key: "actions",
                        thStyle: "width: 15%"
                    },
                ] |> (v => s({
                    field: v,
                    customFunc: r
                })) |> (z => g({
                    field: z
                }))
            );
        }
    },
    methods: {
        goToBayarind(item) {
            window.open(item, '_self');
        },
        convertDate(val) {
            return moment(val).format('DD MMM YYYY HH:mm:ss ')
        },
        convertDateWithoutTime(val) {
            return moment(val).format('DD MMMM YYYY')
        },
        goto(refName) {
            var element = this.$refs[refName];
            var top = element.offsetTop;
            window.scrollTo(0, top);
        },
        async checkBilling() {
            try {
                const res = await this.$axios.get(
                    `billing/package-unpaid?klinik_id=${this.getKlinikId}`
                );
                this.checkDataInvoice = res.data;
            } catch {

            }
        },
        closeModalBatalTransaksi($id) {
            this.$swal({
                title: startCase("Batalkan Transaksi"),
                text: `Apakah Anda yakin untuk membatalkan transaksi ini?`,
                type: "warning",
                showCancelButton: true,
                cancelButtonText: startCase("tidak"),
                confirmButtonText: startCase("ya"),
                confirmButtonColor: "#1791EE"
            }).then(res => {
                if (res.value) {
                    var id_billing = $id
                    this.$axios.delete(`cancelsubscribe/${id_billing}`)
                        .then(res => {
                            this.$swal({
                                title: startCase("Transaksi Anda Berhasil dibatalkan!"),
                                type: "success",
                                confirmButtonText: startCase("OK")
                            }).then(res => {
                                if (res.value) {
                                    this.$refs['modal-bataltransaksi'].hide()
                                    this.$router.go(`/klinik/subskripsi`);
                                } else {

                                }
                            });
                        });
                } else {

                }
            });
        },
        async fetchListNotActive() {
            try {
                const res = await this.$axios.get(
                    `billing/package?page=${this.currentPageNotActive}&klinik_id=${this.getKlinikId}`
                );
                this.dataNotActive = res.data.data.data;
                this.rowsBelumAktif = res.data.data.total;

            } catch (err) {
            }
        },
        caraBayar(id) {
            this.$router.push({
                name: "klinik-subskripsi-bayar",
                params: {
                    bill_id: id
                }
            });
        },
        fetchActive() {
            this.$axios.get(`billing/package-active?klinik_id=${this.getKlinikId}`)
                .then(res => {
                    this.dataActive = res.data
                    this.dataPackage = res.data.data.package
                    this.dataAddOn = res.data.data.add_on
                });
        },
        async fetchListExpired() {
            try {
                const res = await this.$axios.get(
                    `billing/package-expired?page=${this.currentPageExpired}&klinik_id=${this.getKlinikId}`
                );
                this.dataPaketExpired = res.data.data.data;
                this.rowsExpired = this.data.data.total
            } catch (err) {
            }
        },
        determineParameter() {
            const {
                searchValue,
                sortBy,
                sortDesc
            } = this;
            let v = "";
            searchValue.map(item => {
                const x =
                    (item.key === "paket" && "paket") || item.key;
                v += `&${x}=${item.value}`;
            });

            if (sortBy) {
                v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
            }
            return v;
        },
        async fetchRiwayatPembelian() {
            try {
                const res = await this.$axios.get(
                    `billing?limit=${this.perPage}&klinik_id=${this.getKlinikId}&page=${
              this.currentPage
            }${this.determineParameter()}`
                );
                const { success, data } = res.data;
                if (success) {
                    const { total } = data;
                    const {
                        data: listRiwayatPembelian,
                        total: totalEntries,
                        to: toPage,
                        from: fromPage
                    } = data;
                    this.totalEntries = totalEntries;
                    this.toPage = toPage;
                    this.fromPage = fromPage;
                    let statusText = ["Menunggu Pembayaran", "Lunas", "Gagal", "Batal"];
                    let tglBayar = "-"
                    this.dataRiwayatPembelian = [
                        ...listRiwayatPembelian.map((item, index) => {
                            if(item.paket_id == null){
                                item.periode_berlaku = 'Unlimited';
                            }
                            if (item.tanggal_bayar === null) {
                                item.tanggal_bayar = tglBayar
                            }
                            if (item.status === 0) {
                                this.adaTagihan = true
                            }

                            if (item.promo) {
                                if (item.promo.toLowerCase().includes("merdeka")) {
                                    item.promo = "Paket Merdeka " + item.produk.match(/\d+/) 
                                }
                            }
                            return {
                                ...item,
                                no: (this.currentPage - 1) * this.perPage + index + 1,
                                status_text: statusText[item.status],
                            };
                        })
                    ];
                    this.rows = data.total;
                    return this;
                }
            } catch (err) {
            }
        },
        changePage(page) {
            this.fetchListTagihan(page);
        },
        showModalTagihan() {
            this.$refs['modal-bataltransaksi'].show()
        },
        showModalNotActive() {
            this.$refs['modalNotActive'].show()
        },
        hideModalNotActive() {
            this.$refs['modalNotActive'].hide()
        },
        showModal() {
            this.$refs['my-modal'].show()
        },
        hideModal() {
            this.$refs['my-modal'].hide()
        },
        ToInvoice(item) {
            this.detailStruk = item;
            this.$router.push({
                name: "struk-klinik-subskripsi",
                params: {
                    bill_id: this.detailStruk
                }
            });
        },
        detailTagihan(item) {
            this.showModalTagihan()
            this.detailStruk = item;

            this.$axios.get(`detailpembayaran/${this.detailStruk.id}/${this.getKlinikId}`)
                .then(res => {
                    this.dataDetailRiwayatPembelian = res.data.data
                });

        },
        detailNotActive(item, tab) {
            this.currentTab = tab;
            this.showModalNotActive()
            var i = item;
            this.$axios.get(`billing/package/${i}?klinik_id=${this.getKlinikId}`)
                .then((res) => {
                    let dat = res.data.data;
                    let masa_berlaku = dat.durasi;
                    let jml_visit = 0;

                    if(
                        /[0-9]+\ (Visit Pasien).*/.test(dat.nama) ||
                        dat.nama.toLowerCase() == 'unlimited'
                    )
                    {
                        if(dat.nama.toLowerCase() == 'unlimited') {
                            jml_visit = 'unlimited';
                        }
                        else {
                            let res = /([0-9]+)\ (Visit Pasien).*/.exec(dat.nama);
                            jml_visit = res[1];
                        }

                    }

                    this.belumAktif = {
                        ...dat,
                        paket_bln: parseInt(dat.durasi.replace(" Bulan", "")),
                        masa_berlaku,
                        jml_visit
                    }
                });

        },
        detailBayar(item) {
            this.detailStruk = item;
            this.$router.push({
                name: "struk-klinik-subskripsi",
                params: {
                    bill_id: this.detailStruk.id
                }
            });
        },
        handleValueChanged({
            perPage,
            currentPage
        }) {
            perPage && (perPage |> (_ => (this.perPage = _)));
            currentPage && (currentPage |> (_ => (this.currentPage = _)));
        },
        searchValueChanged: debounce(function(val, key) {
            const {
                searchValue
            } = this;
            const z = searchValue.filter(item => item.key !== key);
            this.searchValue = [
                ...z,
                {
                    key,
                    value: val
                }
            ];
        }, 500),
        async fetchUser() {
            const res = await this.$axios.get(`user/${this.$store.state.user.id}?klinik_id=${this.getKlinikId}`);
            const { status, paket, data_paket } = res.data;
            if (status) {
                this.isNewPackage = data_paket.is_new;
                this.currentActivePackage = data_paket.current_active;
                this.lastActivePackage = data_paket.last_active;
            };
      },
    }
}
</script>
<style lang="scss">

.bottom-grey {
    background-color: #f2f2f2 !important;
    border-bottom-right-radius: 15px;
    border-bottom-left-radius: 15px
}

.__card-blue {
    width: 100%;
    border-radius: 8px;
    background-color: #243ee9;
}

.__card-coklat {
    width: 100%;
    border-radius: 8px;
    background-color: #d5720e;
}

.__card-red {
    width: 100%;
    border-radius: 8px;
    background-color: #f40808;
}

.izd-datatable-custom {
  th {
    vertical-align: top !important;
  }
}

td {
  &.tarif-pre-whitespace {
    text-align: right !important;
    white-space: pre;
    padding-right: 2rem;
  }
}

.izd-datatable-custom th {
    text-transform: uppercase;
    background-color: #fcfcfc !important;
    color : #5486b9 !important;     
    font-size: 0.83125rem;
}

.izd-datatable-custom th, .izd-datatable-custom td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid transparent !important;
}


.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0,0,0,.05);
}

.__custom-pagination .page-item .page-link {
    background-color: #b4c9dd !important;
    font-weight: 700;
    color:white;
}

.__custom-pagination .page-item.active .page-link {
    background-color: #759dc0 !important;
    color:white;
    border-color:transparent !important;
}

.__custom-tab .card-header {
    border-width: 0px;
}

.__custom-tab .card-header .nav-tabs .nav-link {
    border: 1px solid transparent;
    border-top-left-radius: 0.52rem;
    border-top-right-radius: 0.52rem;
}

.__custom-tab .card-header .nav-tabs .nav-item .nav-link.active {
    margin-top: 2px;
    padding-bottom: 11px;
    font-weight: 700;
    color: #3c44b1;
    border: none;
    background-color: #f2f2f2;
}

.__custom-tab .card-header {
    padding-right: 0px;
    padding-left: 0px;
    margin: 0px;
}

.__custom-tab .card-header .nav-tabs .nav-item .nav-link {
    color: white;
    font-weight: 700;   
    background-color: #a79e9e;
}

.__custom-tab .tab-content .card-body {
    padding-top: 0px;
    padding-right: 3px;
    padding-left: 3px;
    padding-bottom: 3px;
}

.__custom-tab .card-header .nav-tabs .nav-item {
    padding:0px;
}

.__custom-tab .tab-content {
    background-color: #f2f2f2;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
    border-bottom-left-radius: 15px;
}

.__text-blue {
    color : #5486b9 !important;
}

.__icon_search {
    background-color:#52c3ee;
    color: white;
    border-color: transparent;
}

.btn-paket {
    background-color: #b681fd !important;
    border-color: #b681fd !important;
    color: #ffffff !important;
}

.btn-paket:hover {
    background-color: #ac74fc !important;
    border-color: #ac74fc !important;
    color: #ffffff !important;
}

.btn-radius {
    font-weight: bold;
    border-radius: 0.5em;
    width: 70%;
}

.card_add_on {
    background-color: #dbfbff !important;
}

.font_paket {
    font-weight: bold;
    color: #7a7a7a !important;
}

.btn-masa-berlaku {
    background-color: #33A6EC !important;
    border-color: #33A6EC !important;
    color: #ffffff !important;
}

.btn-masa-berlaku:hover {
    background-color: #33A6EC !important;
    border-color: #33A6EC !important;
    color: #ffffff !important;
}

.alert-perpanjang {
    background-color: #FAFFDC;
}
</style>